import React from 'react';
import { css } from 'aphrodite';
import Tooltip from '@material-ui/core/Tooltip';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppStyles } from '../../styles/AppTheme';
import { MessageActionDialog } from '../../components/MessageActionDialog';
import { Helper } from '../../common/helpers/Helper';
import { AppConfig } from '../../AppConfig';

export class Exports extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageTitle = 'Exports'
    this.toFetch = []
    this.tableHeaders = [
      'Action'
    ]
    this.apiData = {}
    this.headerActions = []
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: this.pageTitle },
    ]
  }

  onFetchSuccess(results) {
    this.setState({
      items: [
        {
          id: 'questions',
          title: 'Export questions'
        },
        {
          id: 'sections',
          title: 'Export sections'
        },
        {
          id: 'users',
          title: 'Export users (anonymized)'
        }
      ]
    })
  }

  onTableValue(current, index) {
    switch (index) {
    case 0:
      return current.title
    default:
      return ''
    }
  }

  onListFetchSuccess = (result) => {
    this.resultLink = result ? result.uri : null
  }

  getTitle = () => {
    if (this.exportType === 'questions') {
      return 'Questions'
    } else if (this.exportType === 'sections') {
      return 'Sections'
    } else if (this.exportType === 'users') {
      return 'Users'
    }
  }

  getApiEndpoint = () => {
    if (this.exportType === 'questions') {
      return ApiHelper.makeUrlPath(['miscs', 'export-questions'], { quizId: AppConfig.quizId })
    } else if (this.exportType === 'sections') {
      return ApiHelper.makeUrlPath(['miscs', 'export-sections'], { quizId: AppConfig.quizId })
    } else if (this.exportType === 'users') {
      return ApiHelper.makeUrlPath(['miscs', 'export-anony-users'])
    }
  }

  downloadFile() {
    const url = this.resultLink
    const link = document.createElement('a');
    link.href = url;
    //link.setAttribute('target', '_blank')
    document.body.appendChild(link);
    link.click();
  }

  renderMessageModal() {
    const title = this.getTitle()
    const apiEndPoint = this.getApiEndpoint()
    return (
      <MessageActionDialog
        title={title}
        isOpen={this.state.messageToShow}
        buttonText={Helper.getString('download')}
        buttonAction={this.downloadFile.bind(this)}
        fullWidth={false}
        apiMethod={'GET'}
        onFetchSuccess={this.onListFetchSuccess.bind(this)}
        apiEndPoint={apiEndPoint}
        apiData={{}}
        onClosed={() => this.setState({ messageToShow: false })}
      />
    )
  }

  openMsgModal(current) {
    this.exportType = current.id
    this.setState({
      messageToShow: true,
    })
  }

  onActions(current) {
    const actions = []
    actions.push(
      <Tooltip title={current.title} placement='top-start' key={current.id + 'file_download'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => this.openMsgModal(current)}>file_download</i>
        </span>
      </Tooltip>
    )
    return actions
  }

}


// WEBPACK FOOTER //
// ./src/screens/admin/Exports.js